/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomerConfig,
  CustomerConfigResponse,
  ErrorResponse,
  PlayerDataCustomerConfig,
} from '../models/index';
import {
    CustomerConfigFromJSON,
    CustomerConfigToJSON,
    CustomerConfigResponseFromJSON,
    CustomerConfigResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PlayerDataCustomerConfigFromJSON,
    PlayerDataCustomerConfigToJSON,
} from '../models/index';

export interface GetCustomerConfigRequest {
    customerId: string;
    xRequestID?: string;
}

export interface GetPlayerDataConfigRequest {
    customerId: string;
    xRequestID?: string;
}

export interface PatchCustomerConfigRequest {
    customerId: string;
    customerConfig: CustomerConfig;
    xRequestID?: string;
}

export interface PatchPlayerDataConfigRequest {
    customerId: string;
    playerDataCustomerConfig: PlayerDataCustomerConfig;
    xRequestID?: string;
}

/**
 * 
 */
export class CustomersApi extends runtime.BaseAPI {

    /**
     */
    async getCustomerConfigRaw(requestParameters: GetCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerConfigResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerConfigResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerConfig(requestParameters: GetCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerConfigResponse> {
        const response = await this.getCustomerConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPlayerDataConfigRaw(requestParameters: GetPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerDataCustomerConfig>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayerDataConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-data-config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerDataCustomerConfigFromJSON(jsonValue));
    }

    /**
     */
    async getPlayerDataConfig(requestParameters: GetPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerDataCustomerConfig> {
        const response = await this.getPlayerDataConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchCustomerConfigRaw(requestParameters: PatchCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerConfig>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling patchCustomerConfig().'
            );
        }

        if (requestParameters['customerConfig'] == null) {
            throw new runtime.RequiredError(
                'customerConfig',
                'Required parameter "customerConfig" was null or undefined when calling patchCustomerConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerConfigToJSON(requestParameters['customerConfig']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerConfigFromJSON(jsonValue));
    }

    /**
     */
    async patchCustomerConfig(requestParameters: PatchCustomerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerConfig> {
        const response = await this.patchCustomerConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchPlayerDataConfigRaw(requestParameters: PatchPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerDataCustomerConfig>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling patchPlayerDataConfig().'
            );
        }

        if (requestParameters['playerDataCustomerConfig'] == null) {
            throw new runtime.RequiredError(
                'playerDataCustomerConfig',
                'Required parameter "playerDataCustomerConfig" was null or undefined when calling patchPlayerDataConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-config"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-data-config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlayerDataCustomerConfigToJSON(requestParameters['playerDataCustomerConfig']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerDataCustomerConfigFromJSON(jsonValue));
    }

    /**
     */
    async patchPlayerDataConfig(requestParameters: PatchPlayerDataConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerDataCustomerConfig> {
        const response = await this.patchPlayerDataConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
